var map = {
	"./Fares-Collections.png": "ffe0",
	"./Halts-Interchanges.png": "753e",
	"./IntelligentTS.png": "931b",
	"./Runningways.png": "72db",
	"./Service.png": "809b",
	"./Vehicles.png": "29e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a7a4";